document.addEventListener('DOMContentLoaded', () => {
  const root = window.Shopify?.routes?.root || '/';
  const menuToggle = () => document.querySelector('[data-menu-toggle]');
  const menuDrawer = () => document.querySelector('[data-menu-drawer]');
  const menuScrim = () => document.querySelector('.menu-scrim');
  let returnFocus = null;
  const closeMenu = () => {
    const drawer=menuDrawer();if(!drawer||drawer.hidden)return;
    drawer.hidden=true;if(menuScrim())menuScrim().hidden=true;
    menuToggle()?.setAttribute('aria-expanded','false');document.body.classList.remove('menu-open');menuToggle()?.focus();
  };
  document.addEventListener('click',event=>{
    const toggle=event.target.closest('[data-menu-toggle]');
    if(toggle){const drawer=menuDrawer();if(!drawer)return;const opening=drawer.hidden;drawer.hidden=!opening;if(menuScrim())menuScrim().hidden=!opening;toggle.setAttribute('aria-expanded',String(opening));document.body.classList.toggle('menu-open',opening);if(opening)drawer.querySelector('[data-menu-close]')?.focus();return;}
    if(event.target.closest('[data-menu-close]'))closeMenu();
  });

  const cartSection = () => document.querySelector('[data-cart-section]');
  const cartDrawer = () => document.getElementById('CartDrawer');
  const cartScrim = () => document.querySelector('.drawer-scrim');
  const closeCart = () => {
    if (!cartDrawer() || cartDrawer().hidden) return;
    cartDrawer().hidden = true;
    cartScrim().hidden = true;
    document.body.classList.remove('cart-open');
    returnFocus?.focus();
  };
  const openCart = () => {
    if (!cartDrawer()) return;
    closeMenu();
    returnFocus = document.activeElement;
    cartDrawer().hidden = false;
    cartScrim().hidden = false;
    document.body.classList.add('cart-open');
    cartDrawer().querySelector('[data-cart-close]')?.focus();
  };
  const refreshCart = async () => {
    const wasOpen = cartDrawer() && !cartDrawer().hidden;
    const response = await fetch(`${root}?section_id=cart-drawer`, { credentials: 'same-origin' });
    if (!response.ok) throw new Error('Impossibile aggiornare il carrello.');
    const html = await response.text();
    const documentFragment = new DOMParser().parseFromString(html, 'text/html');
    const replacement = documentFragment.querySelector('[data-cart-section]');
    if (!replacement || !cartSection()) throw new Error('Il carrello non è disponibile.');
    cartSection().replaceWith(replacement);
    document.querySelectorAll('[data-cart-count]:not([data-cart-section])').forEach(node => { node.textContent = replacement.dataset.cartCount; });
    if (wasOpen) {
      cartDrawer().hidden = false;
      cartScrim().hidden = false;
      cartDrawer().querySelector('[data-cart-close]')?.focus();
    }
  };

  document.addEventListener('click', async event => {
    const opener = event.target.closest('[data-open-cart]');
    if (opener) { if (cartDrawer()) { event.preventDefault(); openCart(); } return; }
    if (event.target.closest('[data-cart-close]')) { closeCart(); return; }
    const change = event.target.closest('[data-cart-change]');
    const remove = event.target.closest('[data-cart-remove]');
    if (!change && !remove) return;
    const button = change || remove;
    button.disabled = true;
    const id = button.dataset.key || button.dataset.cartRemove;
    const quantity = remove ? 0 : Math.max(0, Number(change.dataset.quantity) + Number(change.dataset.cartChange));
    try {
      const response = await fetch(`${root}cart/change.js`, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id, quantity }) });
      if (!response.ok) throw new Error('Non è stato possibile modificare il carrello.');
      await refreshCart();
    } catch (error) {
      button.disabled = false;
      window.location.href = `${root}cart`;
    }
  });

  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') {
      if (cartDrawer() && !cartDrawer().hidden) closeCart();
      else closeMenu();
    }
    if (event.key === 'Tab' && cartDrawer() && !cartDrawer().hidden) {
      const focusable = [...cartDrawer().querySelectorAll('a, button:not([disabled]), input, select')];
      if (!focusable.length) return;
      if (event.shiftKey && document.activeElement === focusable[0]) { event.preventDefault(); focusable.at(-1).focus(); }
      else if (!event.shiftKey && document.activeElement === focusable.at(-1)) { event.preventDefault(); focusable[0].focus(); }
    }
    if (event.key === 'Tab' && menuDrawer() && !menuDrawer().hidden) {
      const focusable = [...menuDrawer().querySelectorAll('a, button:not([disabled]), summary')].filter(el=>el.getClientRects().length);
      if (!focusable.length) return;
      if (event.shiftKey && document.activeElement === focusable[0]) { event.preventDefault(); focusable.at(-1).focus(); }
      else if (!event.shiftKey && document.activeElement === focusable.at(-1)) { event.preventDefault(); focusable[0].focus(); }
    }
  });

  const initProductControls = () => {
  document.querySelectorAll('[data-variant-select]').forEach(select => {
    if(select.dataset.bound)return;select.dataset.bound='true';
    const section = select.closest('[data-product-section]');
    const price = section?.querySelector('[data-product-price]');
    const button = section?.querySelector('[data-add-button]');
    const sync = () => {
      const option = select.selectedOptions[0];
      if (!option) return;
      if (price && option.dataset.price) price.textContent = option.dataset.price;
      if (button) {
        const available = option.dataset.available === 'true';
        button.disabled = !available;
        button.textContent = available ? button.dataset.availableLabel : button.dataset.unavailableLabel;
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', option.value);
      window.history.replaceState({}, '', url);
    };
    select.addEventListener('change', sync);
    sync();
  });

  document.querySelectorAll('form.product-form').forEach(form => {
    if(form.dataset.bound)return;form.dataset.bound='true';
    form.addEventListener('submit', async event => {
      if (!cartDrawer()) return;
      event.preventDefault();
      const button = form.querySelector('[data-add-button]');
      const errorNode = form.querySelector('[data-product-error]');
      if (button?.disabled) return;
      button.disabled = true;
      if (errorNode) errorNode.hidden = true;
      let added = false;
      try {
        const response = await fetch(`${root}cart/add.js`, { method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json' }, body: new FormData(form) });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || 'Non è stato possibile aggiungere il prodotto.');
        added = true;
        await refreshCart();
        openCart();
      } catch (error) {
        if (added) window.location.href = `${root}cart`;
        else if (errorNode) { errorNode.textContent = error.message; errorNode.hidden = false; }
      } finally { const selected = form.querySelector('[data-variant-select]')?.selectedOptions[0]; if (button) button.disabled = !selected || selected.dataset.available !== 'true'; }
    });
  });

  };
  initProductControls();document.addEventListener('shopify:section:load',initProductControls);
  document.addEventListener('change',event=>{if(event.target.matches('[data-localization-select]'))event.target.form?.submit();});
});
